import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartPlus, faShareAlt, faCheck } from '@fortawesome/free-solid-svg-icons'
import { withRouter, useParams, useLocation } from 'react-router-dom'

import { compose } from 'redux'
import { connect } from 'react-redux'
import { actionDetailProduct } from '../../store/actions/product'
import { actionAddCart } from '../../store/actions/cart'
import { actionSettingReferral } from '../../store/actions/util'

import { Loader } from '../../components'
import { getDiscount, formatPrecentage, getCleanUrlReferral, appendReferralIfPresent } from '../../helpers'

import {
  ProductInfo,
  ProductDescription,
  ProductReviews
} from './components'

const Product = ({
  history,
  product,
  cart,
  authenticate,
  util,
  dispatchDetailProduct,
  dispatchAddCart,
  dispatchSettingReferral
}) => {
  const { id } = useParams()
  const location = useLocation()

  const [reviews, setReviews] = useState([])
  const [totalReviews, setTotalReviews] = useState(0)
  const [avgStar, setAvgStar] = useState(0)
  const [starsCount, setStarsCount] = useState({ 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 })
  const [selectedStar, setSelectedStar] = useState(null)
  const [loadingReviews, setLoadingReviews] = useState(true)
  const [pageReviews, setPageReviews] = useState(1)
  const [totalPagesReviews, setTotalPagesReviews] = useState(1)
  const [copied, setCopied] = useState(false)
  const limit = 20

  const activeReferralCode = getCleanUrlReferral(location, history)

  useEffect(() => {
    if (activeReferralCode) {
      dispatchSettingReferral()
    }
  }, [activeReferralCode, dispatchSettingReferral])

  const referralDiscount = activeReferralCode ? util?.settingReferral?.payload?.price_discount : null

  const fetchReviews = (productId, star = null, page = 1) => {
    setLoadingReviews(true)
    let url = `${process.env.REACT_APP_BASE_URL}review-product/${productId}?limit=${limit}&page=${page}`
    if (star !== null) {
      url += `&star=${star}`
    }
    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        if (res.status && res.data) {
          setReviews(res.data.reviews || [])
          setTotalReviews(res.data.total || 0)
          setTotalPagesReviews(res.data.pages || 1)
          setPageReviews(res.data.page || page)
          if (res.data.avg_star !== undefined) setAvgStar(res.data.avg_star)
          if (res.data.stars) setStarsCount(res.data.stars)
        } else {
          setReviews([])
          setTotalReviews(0)
          setTotalPagesReviews(1)
        }
        setLoadingReviews(false)
      })
      .catch(() => {
        setReviews([])
        setTotalReviews(0)
        setTotalPagesReviews(1)
        setLoadingReviews(false)
      })
  }

  useEffect(() => {
    dispatchDetailProduct(id)
    fetchReviews(id, selectedStar, pageReviews)
  }, [id, dispatchDetailProduct])

  const handleFilterStar = (star) => {
    setSelectedStar(star)
    setPageReviews(1)
    fetchReviews(id, star, 1)
  }

  const handlePageChangeReviews = (newPage) => {
    setPageReviews(newPage)
    fetchReviews(id, selectedStar, newPage)
  }

  const handlePageHome = () => {
    history.push(appendReferralIfPresent('/', location))
  }

  const handleGoBack = () => {
    history.goBack()
  }

  const handlePageCart = () => {
    history.push(appendReferralIfPresent('/keranjang', location))
  }

  const outOfStock = product.payload && (
    product.payload.has_stock === false ||
    product.payload.has_stock === 0 ||
    product.payload.has_stock === '0' ||
    product.payload.has_stock === 'false' ||
    product.payload.hasStock === false
  )

  const handleAddToCart = async () => {
    if (outOfStock) return
    const precentage = await formatPrecentage(authenticate.account, product.payload.discount, referralDiscount)
    dispatchAddCart(product.payload, getDiscount(product.payload.price, precentage), 1)
  }

  const handleShareNative = async () => {
    if (!product.payload || outOfStock) return
    const referralCode = localStorage.getItem('referral')
    const baseUrl = window.location.origin
    const shareUrl = referralCode
      ? `${baseUrl}/landing/produk/${product.payload.id}?referral=${referralCode}`
      : `${baseUrl}/produk/${product.payload.id}`

    if (navigator.share) {
      try {
        await navigator.share({
          title: product.payload.name || 'Herbalkatalog',
          text: `Lihat ${product.payload.name || 'produk'} di Herbalkatalog`,
          url: shareUrl
        })
      } catch (err) {
        // User cancelled share action
      }
    } else {
      handleCopyLink(shareUrl)
    }
  }

  const handleCopyLink = (shareUrl) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(shareUrl).then(() => {
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
      }).catch(() => {
        fallbackCopyText(shareUrl)
      })
    } else {
      fallbackCopyText(shareUrl)
    }
  }

  const fallbackCopyText = (text) => {
    const textField = document.createElement('textarea')
    textField.innerText = text
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  if (product.loading || !product.payload) return <Loader />

  // if (referralParam) {
  //   history.replace(`/landing/produk/${id}?referral=${referralParam}`)
  //   return <Loader />
  // }

  return (
    <div className="bg-white">
      <div
        onClick={handlePageCart}
        className="floating-shop"
      >
        <a className="menu-mobile">
          <FontAwesomeIcon className="fas" icon={faCartPlus} />
        </a>
        {
          (cart.payload.length > 0)
            ? <div className="notif">{cart.payload.length}</div>
            : null
        }
      </div>

      <div className="btn-cover-mobile">
        <div className="btn-cover-mobile-left">
          {outOfStock ? (
            <a className="btn-bagikan btn-bagikan-disabled">
              <FontAwesomeIcon icon={copied ? faCheck : faShareAlt} /> {copied ? 'Tersalin!' : 'Bagikan'}
            </a>
          ) : (
            <a onClick={handleShareNative} className="btn-bagikan">
              <FontAwesomeIcon icon={copied ? faCheck : faShareAlt} /> {copied ? 'Tersalin!' : 'Bagikan'}
            </a>
          )}
        </div>
        <div className="btn-cover-mobile-right">
          <a onClick={handleGoBack} className="btn-kembali">Kembali</a>
          {outOfStock ? (
            <a className="btn-keranjang btn-keranjang-disabled">Stok Habis</a>
          ) : (
            <a onClick={handleAddToCart} className="btn-keranjang">Masukan keranjang</a>
          )}
        </div>
      </div>

      <div className="breadcrumb-halaman">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a
                onClick={handlePageHome}
                className="clickable"
              >Beranda</a>
            </li>
            <li className="breadcrumb-item active">Detail produk</li>
          </ol>
        </nav>
      </div>

      <div className="container">
        <ProductInfo
          productPayload={product.payload}
          account={authenticate.account}
          referralDiscount={referralDiscount}
          handleGoBack={handleGoBack}
          handleAddToCart={handleAddToCart}
          handleShareNative={handleShareNative}
          copied={copied}
        />

        <ProductDescription
          description={product.payload.description}
        />

        <ProductReviews
          reviews={reviews}
          totalReviews={totalReviews}
          avgStar={avgStar}
          starsCount={starsCount}
          selectedStar={selectedStar}
          loadingReviews={loadingReviews}
          handleFilterStar={handleFilterStar}
          page={pageReviews}
          totalPages={totalPagesReviews}
          handlePageChange={handlePageChangeReviews}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    authenticate: {
      account: state.auth.authenticate.account
    },
    product: {
      loading: state.product.detailProduct.loading,
      payload: state.product.detailProduct.payload
    },
    cart: {
      payload: state.cart.getCart.payload
    },
    util: {
      contact: state.util.contact,
      settingReferral: state.util.settingReferral
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchDetailProduct: (productId) => dispatch(actionDetailProduct(productId)),
    dispatchAddCart: (product, price, quantity, isSilent) => dispatch(actionAddCart(product, price, quantity, isSilent)),
    dispatchSettingReferral: () => dispatch(actionSettingReferral())
  }
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Product)